import RadioGroup from './radio-group.vue'
export type { RadioGroupProps } from './props'
export default RadioGroup